import React, { Component } from 'react';
import style from './HopInnHeader.module.css';
import logoImage from '../assets/images/header_logo2.svg';
import BackDrop from './BackDrop';

class HopInnHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showMenu: false
            // dataObject: null,
            // validateObject: null,
            // loading: true
        };
    }
    userMenuToggle = () => {
        //alert("tof");
        let showMenu = this.state.showMenu;
        if (showMenu !== true) {
            showMenu = true;
        }
        else {
            showMenu = false;
        }

        this.setState({
            showMenu: showMenu
        });
    }
    logout =()=>{
        //window.localStorage.setItem("userObject", JSON.stringify(dataObject));
        //window.localStorage.removeItem("userObject"); 
        //window.location.reload(); 

        this.props.appState.logout();

    }



    render() {
        let userObject = this.props.appState.userObject;

        //console.log(userObject);


        let displayName = "";

        if (userObject !== null) {
            displayName = userObject.FirstName + " " + userObject.LastName;
        }

        //console.log("header");
        //console.log(userObject);


        return (
            <div className={style.header}>

                <div className={style.header_c1}>

                </div>

                <div className={style.header_c2}>

                    <img src={logoImage} alt="logo" />
                </div>

                <div className={style.header_c3}>
                    COMPANY MANAGEMENT
                    </div>

                <div className={style.userContent}>
                    <div className={style.pointDown} onClick={this.userMenuToggle}><i className="fas fa-sort-down"></i></div>
                    <div className={style.human}><i className="far fa-user"></i></div>
                    <div className={style.name}>Welcome,{displayName}</div>
                </div>
                {
                    this.state.showMenu === true &&
                    <>
                        <BackDrop show={true} onClick={this.userMenuToggle}/>
                        <div id="inside" className={style.menuArea}>
                            <div className={style.menuRow}>
                                <div className={style.menuIcon}>
                                    <i className="fas fa-sign-out-alt"></i>
                                </div>
                                <div className={style.menuLabel} onClick={this.logout}>
                                    Logout
                                </div>
                            </div>
                        </div>
                    </>

                }
            </div>
        );
    }
}
export default HopInnHeader;